import axios from 'axios';

// Use environment variable or Render URL in production, relative path in development
// Since React app is served from the same server in production, relative URLs work
// But we keep the Render URL as a fallback/option
const baseURL = process.env.REACT_APP_API_URL 
  || (process.env.NODE_ENV === 'production' 
    ? 'https://bspl-j4js.onrender.com/api'
    : '/api');

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect to login if we're actually on an admin page
    if (error.response?.status === 401 && window.location.pathname.startsWith('/admin')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/admin/login';
    }
    // For other errors, just reject but don't break the app
    return Promise.reject(error);
  }
);

export default axiosInstance;




